import { render } from "./PasswordEmail.vue?vue&type=template&id=ef7e8594&scoped=true&ts=true"
import script from "./PasswordEmail.vue?vue&type=script&lang=ts"
export * from "./PasswordEmail.vue?vue&type=script&lang=ts"

import "./PasswordEmail.vue?vue&type=style&index=0&id=ef7e8594&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7e8594"]])

export default __exports__